import { throttle } from './lib/throttle'

function setWidth() {
    const value = window.innerWidth - document.documentElement.clientWidth
    document.documentElement.style.setProperty(
        '--scrollbar-width',
        value + 'px'
    )
}

window.addEventListener('resize', throttle(setWidth, 100))

setWidth()
